module.exports = __webpack_public_path__ + "static/media/study-group.d11b006f.png";